import { render, staticRenderFns } from "./ClientDuplicatesDialog.vue?vue&type=template&id=3139b4dd&scoped=true"
import script from "./ClientDuplicatesDialog.vue?vue&type=script&lang=js"
export * from "./ClientDuplicatesDialog.vue?vue&type=script&lang=js"
import style0 from "./ClientDuplicatesDialog.vue?vue&type=style&index=0&id=3139b4dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3139b4dd",
  null
  
)

export default component.exports